import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api/client';
import type { RegisterRequest, AuthResponse } from '@lov/shared';

export function useRegister() {
  return useMutation({
    mutationFn: async (data: RegisterRequest) => {
      const response = await apiClient.post<AuthResponse>('/auth/register', data);
      return response.data;
    },
  });
}
